import { render, staticRenderFns } from "./AddAnswerButton.vue?vue&type=template&id=670790e2&scoped=true"
import script from "./AddAnswerButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAnswerButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddAnswerButton.vue?vue&type=style&index=0&id=670790e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670790e2",
  null
  
)

export default component.exports